<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>Import a Resource</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-col class="shrink">
        <v-menu :close-on-content-click="false">
          <template v-slot:activator="{ on: onMenu }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: onTip }">
                <v-btn icon v-on="{ ...onTip, ...onMenu }"><v-icon>library_add</v-icon></v-btn>
              </template>
              Add Research
            </v-tooltip>
          </template>
          <add-resource-widget @created="$emit('openResource', $event)"></add-resource-widget>
        </v-menu>
      </v-col>
      <v-col class="shrink">
        <v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
      </v-col>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            prepend-icon="search"
            placeholder="Search for Resources or Contexts"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h2>Recent Resources</h2>
        </v-col>
        <v-col>
          <v-list>
            <v-list-item @click="">
              <v-list-item-title>My Resource</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h2>Recent Contexts</h2>
        </v-col>
        <v-col>
          <v-list>
            <v-list-item @click="">
              <v-list-item-title>My Context</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AddResourceWidget from '@/components/Resources/AddResourceWidget';
export default {
  components: { AddResourceWidget }
};
</script>

<style></style>
